import React from 'react';
import PropTypes from 'prop-types';
import './OrdenesStyles.css';

const OrdenesLoadingSkeleton = ({ variant = 'list', rows = 4, text = 'Estamos preparando el listado de ordenes...' }) => {
    if (variant === 'inline') {
        return (
            <span className="ordenes-inline-loading" aria-busy="true" aria-live="polite" role="status">
                <span className="ordenes-skeleton-block ordenes-skeleton-block--inline" />
                <span className="ordenes-inline-loading__text">Procesando...</span>
            </span>
        );
    }

    if (variant === 'detail') {
        return (
            <div className="ordenes-loading" aria-busy="true" aria-live="polite">
                <div className="ordenes-loading__header">
                    <span className="ordenes-loading__badge">Cargando orden</span>
                    <p className="ordenes-loading__text">Estamos preparando los datos de la orden...</p>
                </div>

                <div className="ordenes-detail-loading-card">
                    <span className="ordenes-skeleton-block ordenes-skeleton-block--detail-title" />
                    <div className="ordenes-detail-loading-tabs">
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--tab" />
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--tab" />
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--tab" />
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--tab" />
                    </div>
                    <span className="ordenes-skeleton-block ordenes-skeleton-block--detail-line" />
                    <span className="ordenes-skeleton-block ordenes-skeleton-block--detail-line-short" />
                    <span className="ordenes-skeleton-block ordenes-skeleton-block--detail-footer" />
                </div>
            </div>
        );
    }

    return (
        <div className="ordenes-loading" aria-busy="true" aria-live="polite">
            <div className="ordenes-loading__header">
                <span className="ordenes-loading__badge">Actualizando resultados</span>
                <p className="ordenes-loading__text">{text}</p>
            </div>

            {Array.from({ length: rows }).map((_, index) => (
                <div key={`orden-loading-${index}`} className="ordenes-loading-card">
                    <div className="ordenes-loading-card__upload">
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--button" />
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--caption" />
                    </div>

                    <div className="ordenes-loading-card__content">
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--title" />
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--line" />
                        <span className="ordenes-skeleton-block ordenes-skeleton-block--line-short" />
                    </div>
                </div>
            ))}
        </div>
    );
};

OrdenesLoadingSkeleton.propTypes = {
    variant: PropTypes.oneOf(['list', 'detail', 'inline']),
    rows: PropTypes.number,
    text: PropTypes.string,
};

export default OrdenesLoadingSkeleton;
